export default function Checkbox({ name, label, comment, onChange, input }) {
    return (
        <div className="relative flex items-start">
            <div className="flex h-5 items-center">
                <input
                    name={name}
                    id={input?.name ? input.name : name}
                    {...input}
                    onChange={(e) => {
                        input && input.onChange(e.target.checked)
                        onChange && onChange(e.target.checked)
                    }}
                    type="checkbox"
                    className="h-4 w-4 rounded border-stone-400 text-orange-600 focus:ring-orange-500"
                />
            </div>
            <div className="ml-3 text-sm">
                {label && (
                    <label htmlFor={input?.name ? input.name : name} className="font-medium text-gray-700">
                        {label}
                    </label>
                )}

                {comment && (
                    <p id="comments-description" className="text-gray-500">
                        {comment}
                    </p>
                )}
            </div>
        </div>
    );
}
